export class Register {
  
  constructor(public email: string, public password: string, public name: string, public nif?: string) {
  }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/register/Register.ts
 **/